<div class="stepper">
  @for (step of steps; track step) {
    <div class="step" [ngClass]="'step-'+step.state" >
      <div>
        <div class="circle">
          @if (step.state===stepStates.DONE) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </div>
      <div class="border-container">
      </div>
      <div class="text-container">
        <h6 class="title mb-2">{{step.title|translate}}</h6>
        <div class="mb-3">{{step.description|translate}}
        </div>
      </div>
    </div>
  }
</div>
